import { Chip, styled } from "@mui/material";

const ChipAdd = styled(Chip)({
  marginRight: 8
});

export default ChipAdd;
